<template>
  <main
    class="flex min-h-screen items-center justify-center bg-background px-4 text-foreground"
  >
    <div class="flex items-center gap-3 text-sm text-muted-foreground">
      <Spinner class="size-4" />
      {{ t("auth.callbackLoading") }}
    </div>
  </main>
</template>

<script setup lang="ts">
import { Spinner } from "@/components/ui/spinner";
import { useI18n } from "@/lib/i18n";

const { t } = useI18n();
</script>
